/**
 * Asks Shopify's image CDN for a resized copy, so a list of thumbnails does
 * not download every full-size product photo. Other hosts are left untouched.
 */
export function shopifyThumbnail(url: string, width: number): string {
  try {
    // Resolved against the page, so a protocol-relative `//cdn.shopify.com`
    // URL is resized too; a relative one lands on our host and is left alone.
    const parsed = new URL(url, window.location.href);
    const isShopifyCdn =
      parsed.hostname === "cdn.shopify.com" ||
      parsed.pathname.startsWith("/cdn/shop/");
    if (!isShopifyCdn) return url;
    parsed.searchParams.set("width", String(width));
    return parsed.toString();
  } catch {
    return url;
  }
}
